module.exports = __webpack_public_path__ + "static/media/SlatePro-BoldItalic.8d866402.otf";